import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DatatableTables from "./DatatableTables"
import MetaTag from "components/Common/Meta-tag"

function Banner() {
  return (
    <>
      <MetaTag title={"All Banners"} />

      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="All Banners" />
        <Container fluid>
          <div className="container-fluid">
            <DatatableTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default Banner
